<ng-container *transloco="let t">
  <div class="mx-auto flex h-full w-[1230px] overflow-hidden rounded-3xl border border-slate-100">
    <div class="flex flex-[1_1_0] flex-col gap-4 px-20 pt-10">
      <div>
        <app-account-link-illustration />
        @if (errorMessage()) {
          <IAlert [title]="errorMessage()!" type="error" />
        }
        <div>
          @if (fromOnboarding()) {
            <span class="text-xs text-gray-400">1/3</span>
          }
          <div class="text-xl font-semibold text-gray-700">{{ t("link-your-account-button.link_account") }}</div>

          @if (!selectAccountsStep()) {
            <div class="mt-2 text-sm text-gray-500">
              @if (fromOnboarding()) {
                {{ t("link-your-account-button.to_get_started", [agency]) }}
              } @else {
                {{ t("link-your-account-button.link_accounts_to_add", [agency]) }}
              }
            </div>
          } @else {
            <div class="mt-2 text-sm text-gray-500">
              {{ t("link-your-account-button.select_accounts", [agency]) }}
            </div>
          }
        </div>
      </div>

      @if (!selectAccountsStep()) {
        <div>
          <button
            iButton
            variant="secondary"
            size="md"
            [loading]="loading()"
            testId="amazon-linking-button"
            (click)="loginWithAmazon()"
          >
            <IIcon name="amazon" />
            {{ t("onboarding.login_with_amazon") }}
          </button>

          <div class="mt-2 text-xs text-gray-500">
            {{ t("link-your-account-button.closed_popup_window") }}
            <span class="cursor-pointer underline" (click)="loginWithAmazon()">{{
              t("link-your-account-button.click_here_to_reopen")
            }}</span>
          </div>
        </div>
      } @else {
        <div class="flex min-h-0 flex-[1_1_0] flex-col overflow-auto bg-white px-1 py-3">
          <div class="min-h-0 flex-1">
            <app-select-accounts-page
              [accountMarketplaces]="accountMarketplaces()!"
              [orgId]="orgId()!"
              [loading]="loading()"
              (cancellation)="onCancel()"
              (selectionChange)="selectionChange($event)"
            />
          </div>
          <div class="flex justify-between">
            <button iButton variant="secondary" size="md" (click)="onCancel()" [disabled]="loading()">
              {{ t("common.cancel") }}
            </button>
            <button
              iButton
              size="md"
              [disabled]="!selectedAccountMarketplaces()?.length"
              (click)="createAccounts()"
              [loading]="loading()"
              testId="continue-button"
            >
              {{ t("common.continue") }}
            </button>
          </div>
        </div>
      }
    </div>

    @if (!selectAccountsStep()) {
      <div class="relative flex h-full min-h-[80vh] flex-1 items-center justify-center overflow-hidden bg-slate-50">
        <div
          class="absolute bottom-0 left-0 z-10 h-[200px] w-full bg-[linear-gradient(rgba(244,_245,_246,_0)_0%,_rgb(244,_245,_246)_100%)]"
        ></div>
        <div class="translate-x-[15%] translate-y-[26%] scale-125">
          <img src="assets/img/onboarding/board_illustration.svg" alt="" />
        </div>
      </div>
    }
  </div>
</ng-container>
